import React, {useEffect, useState} from "react";
import {
    Card,
    Page,
    Layout,
} from "@shopify/polaris";
import {useGoTo} from "../Lib/useGoTo";


function BulkHelp() {
    const [loading, setLoading] = useState(false);
    const goTo = useGoTo();


    useEffect(() => {
    }, []);


    return (
        <Page title={'How to Bulk Import Size Charts'} backAction={{content: 'Home', onAction() {goTo('')}}}>
            <Layout>
                    <Layout.Section>
                        <Card roundedAbove="sm">
                            <p>With the ESC ‑ Size Charts & Size Guide, you can easily bulk import multiple size charts
                                using a text file. Follow these steps:</p>

                            <ol>
                                <li>Click the "Bulk Import" Button</li>
                                <p>Start by clicking the "Bulk Import" button to begin the process.</p>

                                <li>Select a Text File</li>
                                <p>A modal window will appear. In this window, select a text file from your computer
                                    that contains the size chart information.</p>

                                <p>
                                    <strong>You can have multiple size guides in each file. The title filed is
                                        mandatory.</strong>
                                    <br/>
                                    <br/>
                                </p>


                                <p>Ensure that your text file follows the correct format:</p>
                                <pre>
        @title,"Bulk title 1"<br/>
        @tag,"tag1,tag2"<br/>
        @text1,"Above text"<br/>
        @text2,"Below text"<br/>
        @enabled,"true"<br/>
        @chart<br/>
        "Size","S","M","L"<br/>
        "Chest (IN)","32" - 34"","34" - 36"","36" - 38""<br/>
        "Chest (cm)","81 - 86","86 - 91","91 - 96"<br/>
        @chart-end<br/>
        @title,"Bulk title 2"<br/>
        @tag,"tag3,tag4"<br/>
        @text1,"Above text"<br/>
        @text2,"Below text"<br/>
        @enabled,"true"<br/>
        @chart<br/>
        "Size","S","M","L"<br/>
        "Chest (IN)","32" - 34"","34" - 36"","36" - 38""<br/>
        "Chest (cm)","81 - 86","86 - 91","91 - 96"<br/>
        @chart-end
        </pre>

                                <li>Upload the Text File</li>
                                <p>Select a text file using the file button to proceed.</p>

                                <li>Review Imported Size Charts</li>
                                <p>The app will process the text file and import the size charts.</p>

                                <li>Manage Your Size Charts</li>
                                <p>The app will show a "The file was successfully imported." message and the new charts
                                    will appear on the dashboard.</p>
                            </ol>

                            <p>If you have any questions or encounter any issues during the bulk import process, please
                                reach out to our support team for assistance.</p>
                        </Card>
                        <div>
                            <br/>
                        </div>
                    </Layout.Section>
            </Layout>
        </Page>
    );
}

export default BulkHelp;
